'use client';

import { Box } from '@terra/ui-styled-system';
import { automationId } from '@terra/shared-utils';
import { Switch } from '../../components/switch';
import { Tooltip } from '../../components/tooltip';

type DomainScopeSwitchProps = {
  checked: boolean;
  disabled?: boolean;
  tooltip: string;
  onCheckedChange: () => void;
  dataTestid?: string;
};

export const DomainScopeSwitch = ({
  checked,
  disabled,
  tooltip,
  onCheckedChange,
  dataTestid,
}: DomainScopeSwitchProps) => (
  <Tooltip title={tooltip}>
    <Box w="fit-content" display="inline-flex" overflow="visible">
      <Switch
        size="sm"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
        aria-label={tooltip}
        {...(dataTestid ? automationId(dataTestid) : {})}
      />
    </Box>
  </Tooltip>
);
